module.exports = __webpack_public_path__ + "static/ht-fb289ca05aec82435254286e5410df58.svg";